import { NoYesNotApplicable } from "@/Patient/Models/ObstetricalFile/BritishColumbia/Enum/NoYesNotApplicable";
import { NoYesUndecided } from "@/Patient/Models/ObstetricalFile/BritishColumbia/Enum/NoYesUndecided";
import { PregnancyType } from "./PregnancyType";

class BritishColumbiaObstetricalFilePerinatalConsiderationsAndReferrals {
    public PregnancyType?: PregnancyType;
    public VaginalBirthAfterCesareanEligibleAt36Weeks?: NoYesNotApplicable;
    public VaginalBirthAfterCesareanPlannedAt36Weeks?: NoYesNotApplicable;
    public PlanToBreastfeed?: NoYesUndecided;
    public LifestyleAndSubstanceUse: string;
    public Pregnancy: string;
    public LabourAndBirth: string;
    public Breastfeeding: string;
    public Postpartum: string;
    public ContraceptionPlan: string;
    public Newborn: string;

    public constructor(fields?: Partial<BritishColumbiaObstetricalFilePerinatalConsiderationsAndReferrals>) {
        Object.assign(this, fields);
    }
}

export { BritishColumbiaObstetricalFilePerinatalConsiderationsAndReferrals };
